import { ChevronLeft, ChevronRight } from 'lucide-react';
import React, { useEffect } from 'react';
import { useChatbot } from '../../contexts/ChatbotContext';
import { useGallerySystem } from '../../hooks/useGallerySystem';

export function GalleryApp() {
  const { chatbotPublicId } = useChatbot();
  const { settings, images, loading, initialize } = useGallerySystem();
  const [currentIndex, setCurrentIndex] = React.useState(0);

  useEffect(() => {
    if (chatbotPublicId) {
      initialize(chatbotPublicId);
    }
  }, [chatbotPublicId, initialize]);

  if (loading.initialize && images.length === 0) {
    return (
      <div className="flex justify-center items-center h-[500px]">
        <div className="animate-spin rounded-full h-8 w-8 border-t-2 border-b-2 border-indigo-500" />
      </div>
    );
  }

  if (images.length === 0) {
    return (
      <div className="text-center text-gray-500 p-4">
        No images in the gallery
      </div>
    );
  }

  if (settings.displayMode === 'carousel') {
    return (
      <div className="relative w-full h-[500px]">
        <img
          src={images[currentIndex].url}
          alt={images[currentIndex].title || ''}
          className="w-full h-full object-contain"
        />
        
        {images.length > 1 && (
          <>
            <button
              onClick={() => setCurrentIndex((prev) => (prev === 0 ? images.length - 1 : prev - 1))}
              className="absolute left-4 top-1/2 -translate-y-1/2 p-2 rounded-full bg-black/50 text-white hover:bg-black/70 transition-colors"
            >
              <ChevronLeft className="w-6 h-6" />
            </button>
            <button
              onClick={() => setCurrentIndex((prev) => (prev === images.length - 1 ? 0 : prev + 1))}
              className="absolute right-4 top-1/2 -translate-y-1/2 p-2 rounded-full bg-black/50 text-white hover:bg-black/70 transition-colors"
            >
              <ChevronRight className="w-6 h-6" />
            </button>
          </>
        )}
      </div>
    );
  }

  const gridStyle = {
    display: 'grid',
    gridTemplateColumns: `repeat(${settings.gridColumns}, 1fr)`,
    gap: `${settings.spacing * 0.25}rem`,
  };

  return (
    <div className="w-full h-[500px] overflow-y-auto p-4">
      <div style={gridStyle}>
        {images.map((image) => (
          <div 
            key={image.id}
            className={settings.displayMode === 'masonry' ? 'break-inside-avoid' : ''}
          >
            <img
              src={image.url}
              alt={image.title || ''}
              className="w-full aspect-square object-cover rounded-lg"
            />
          </div>
        ))}
      </div>
    </div>
  );
}